(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory(
      'FacilityKarcherDetailsViewModel',
      facilityKarcherDetailsViewModelFactory
    );

  /** @ngInject */
  function facilityKarcherDetailsViewModelFactory(
    invariant,
    modelUtils,
    moment,
    layoutActions,
    $translate,
    $timeout,
    feedVisibility,
    sessionData,
    $state
  ) {
    function FacilityKarcherDetailsViewModel() {
      // Global object that includes all component lists and activePath property
      // (important for actuator and feed via webSockets update)
      this.globalListObject = {};

      this.deviceSerial = '';
      this.deviceId = null;
      this.status = '';
      this.lastReportTimestamp = null;
      this.facilityName = '';
      this.facilityId = null;
      this.facilityIdForQrCode = '';
      this.facilityType = '';
      this.weatherIcon = '';
      this.feedReferences = {};
      this.changeOfParametersData = {};
      this.facilityIcon = '';
      this.machineType = '';
      this.materialNumber = '';
      this.numberOfAlarms = { warnings: 0, alarms: 0 };
      this.siteAddress = '';
      this.siteLatitude = '';
      this.siteLongitude = '';
      this.currentWeatherData = {
        country: '',
        city: '',
        region: '',
        temperature: '',
        currentWeatherIcon: ''
      };
      this.speedsPointId = null;
      this.dosingPointId = null;
      this.programPointId = null;
      this.installationDateOfMachine = '';

      this.deviceList = [];
      this.alarmList = [];
      this.selectedDevice = null;
      this.operationCounterList = [];
      this.operationCounterObject = {};
      this.programList = [];
      this.pumpsList = [];
      this.activeProgramItem = null;
      this.dosingList = [];
      this.speedList = [];
      this.listOfExistingChemicals = [];
      this.rolloverOperationCounterList = [];
      this.rolloverServiceCounterList = [];
      // For mapping name of active program. Embedded need to add name in active program actuators
      this.activeProgramActuators = [];
      this.maintenanceDays = '';
      this.maintenanceWashes = '';
      this.serviceOnOperationCountersDeviceNeeded = false;

      // List of active actuator from components. Important for web socket data update
      this.rolloverSpeedsActuatorList = [];
      this.rolloverDosingActuatorList = [];
      this.rolloverParametersActuatorList = [];
      this.speedsPointPath = '';
      this.dosingPointPath = '';
      this.programPointPath = '';
      this.activeProgramUpdatedFeed = null;
      this.componentCollapseDefaultState = true;

      this.activePath = '';
      this.fromWebSocketsEventData = null;

      // Grid data
      this.alarmsOrderBy = 'timestamp';
      this.alarmsOrder = 'desc';
      this.alarmsPage = 1;
      this.alarmsTotal = 0;
      this.alarmsPageSize = 5;
      this.alarmsPageOptions = [5];
      this.pagerTranslations = {
        page: $translate.instant('GRID_PAGER_PAGE'),
        rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
        of: $translate.instant('GRID_PAGER_PAGE_OF')
      };
    }

    FacilityKarcherDetailsViewModel.prototype.destroy = function () {};

    FacilityKarcherDetailsViewModel.prototype.mapActiveProgramName = function (
      programId,
      programList
    ) {
      for (var i = 0; i < programList.length; i++) {
        for (var j = 0; j < programList[i].feeds.length; j++) {
          if (
            programList[i].feeds[j].reference === 'ID' &&
            programList[i].feeds[j].currentValue === programId + '.0'
          ) {
            this.activeProgramActuators = programList[i].actuators;
          }
        }
      }
    };

    FacilityKarcherDetailsViewModel.prototype.alarmsPaginationChanged =
      function (page, limit) {
        this.alarmsPage = page;
        this.alarmsPageSize = limit;
      };

    FacilityKarcherDetailsViewModel.prototype.alarmsOrderingChanged = function (
      order
    ) {
      var orderQuery = getOrderObject(order);
      this.alarmsOrderBy = orderQuery.orderBy;
      this.alarmsOrder = orderQuery.order;
    };

    FacilityKarcherDetailsViewModel.prototype.refreshAlarmList = function (
      data
    ) {
      if (data.content.length === 0) {
        this.alarmList = [];
        this.alarmList.push({
          timestamp: $translate.instant('NOTHING_TO_DISPLAY')
        });
        this.numberOfAlarms = countAlarmsType(data.content);
      } else {
        this.alarmList = this.setStateIcon(data.content, false);
        this.numberOfAlarms = countAlarmsType(data.content);
      }
      this.alarmsTotal = data.totalElements;
      layoutActions.hideLoader();
    };

    FacilityKarcherDetailsViewModel.prototype.refreshChangerAlarmList = function (
      alarms
    ) {
      var that = this;
      this.alarmList = [];
      this.numberOfAlarms = { warnings: 0, alarms: 0 };

      if (alarms === null || alarms.length === 0) {
        this.alarmList.push({
          timestamp: $translate.instant('NOTHING_TO_DISPLAY')
        });
        this.alarmsTotal = 0;
      } else {
        this.alarmList = alarms.map(function (alarm) {
          var isAlarm = alarm.collapseKey === 'alarm';
          if (isAlarm) {
            that.numberOfAlarms.alarms++;
          } else {
            that.numberOfAlarms.warnings++;
          }
          return {
            timestamp: alarm.timestamp,
            timeFormatted: moment(alarm.timestamp).fromNow(),
            karcherFault: {
              name: alarm.localizedContent || alarm.content,
              description: alarm.localizedContent || alarm.content,
              washFacilityStatus: isAlarm ? 'ALARM' : 'WARNING'
            },
            companyName: '',
            siteName: '',
            washFacilityName: alarm.washFacilityName || that.facilityName,
            icon: isAlarm
              ? 'assets/icons/ic_high_alarm.svg'
              : 'assets/icons/ic_medium_alarm.svg'
          };
        });
        this.alarmsTotal = alarms.length;
      }
      layoutActions.hideLoader();
    };

    FacilityKarcherDetailsViewModel.prototype.setStateIcon = function (
      data,
      switcher
    ) {
      for (var i = 0; i < data.length; i++) {
        var caseItem = switcher
          ? data[i].status
          : data[i].karcherFault.washFacilityStatus;
        switch (caseItem) {
          case 'INFO':
            data[i].icon = 'assets/icons/ic_low_alarm.svg';
            break;
          case 'WARNING':
            data[i].icon = 'assets/icons/ic_medium_alarm.svg';
            break;
          case 'ALARM':
            data[i].icon = 'assets/icons/ic_high_alarm.svg';
            break;
          default:
            data[i].icon = 'assets/icons/ic_low_alarm.svg';
            break;
        }
      }
      return data;
    };

    FacilityKarcherDetailsViewModel.prototype.refreshFacilityData = function (
      data
    ) {
      // After update, need to empty listed arrays
      // TO-DO: Every list need to be a part of this.globalListObject
      this.rolloverOperationCounterList = [];
      this.rolloverServiceCounterList = [];
      this.operationCounterList = [];
      this.listOfExistingChemicals = [];
      this.activePath = data.deviceKey + '/' + data.point.id;
      // Resolve routing problem
      if (angular.isArray(data)) {
        layoutActions.hideLoader();
        $state.go('app.dashboardTechnology');
        return;
      }
      var that = this;
      // Remove deleted points
      data.point.points = data.point.points.filter(function (point) {
        return !point.name.includes(' ');
      });
      this.selectedDevice = data;
      // For wash bay details tab (development preview)
      this.copyOfSelectedDevice = angular.copy(data);
      // ==============================================
      this.deviceSerial = data.deviceKey;
      this.deviceId = data.id;
      this.status = data.state;
      this.lastReportTimestamp = moment(data.lastReportTimestamp).fromNow();
      this.facilityName = data.point.name;
      this.facilityId = data.point.id;
      this.facilityIdForQrCode = data.point.id.toString();
      this.facilityType = data.facilityType;
      this.facilityIcon = this.setFacilityIcon(data);
      this.machineType = data.deviceType;

      // Map facility feeds
      data.point.feeds.forEach(function (feed) {
        that.feedReferences[feed.reference] = feed.currentValue;
        if (
          feed.reference === 'SETUP_UNIT_MATERIAL_NO' ||
          feed.reference === 'MATERIAL_NO'
        ) {
          that.materialNumber = feed;
        } else if (
          feed.reference === 'SETUP_UNIT_SERIAL_NO' ||
          feed.reference === 'SERIAL_NO'
        ) {
          that.serialNumber = feed;
        } else if (feed.reference === 'SOFTWARE_DATE') {
          that.softwareDate = feed;
        } else if (feed.reference === 'SOFTWARE_VERSION') {
          that.softwareVersion = feed;
        } else if (feed.reference.includes('CHEM_LEVEL_LOW')) {
          that.listOfExistingChemicals.push(
            feed.reference.split('CHEM_LEVEL_LOW_')[1]
          );
        } else if (feed.reference === 'STATUS_ID') {
          that.rolloverStatus = feed.currentValue;
        } else if (feed.reference.includes('OPERATION_COUNTER_')) {
          that.rolloverOperationCounterList.push(feed);
        } else if (feed.reference.includes('SERVICE_COUNTER_')) {
          that.rolloverServiceCounterList.push(feed);
        } else if (
          feed.reference === 'WEB_API_VERSION' ||
          feed.reference === 'WEBAPI_VERSION' ||
          feed.reference === 'SETUP_UNIT_WEBAPI_VERSION'
        ) {
          that.machineType =
            that.machineType + '_' + feed.currentValue.replaceAll('.', '_');
        } else if (feed.reference === 'MAINTENANCE_WASHES') {
          that.maintenanceWashes = feed.currentValue;
        } else if (feed.reference === 'MAINTENANCE_DAYS') {
          that.maintenanceDays = feed.currentValue;
        } else if (feed.reference === 'DATE_COMMISSIONING') {
          that.installationDateOfMachine = feed;
        }
      });

      this.chemicalLevelList = this.createChemicalLevelList(data.point.feeds);

      this.feedReferences.OP_TEMPERATURA_MJERENA = this.feedReferences
        .OP_TEMPERATURA_MJERENA
        ? this.feedReferences.OP_TEMPERATURA_MJERENA
        : this.feedReferences.TEMPERATURE;
      this.weatherIcon = setWeatherIcon(
        parseFloat(this.feedReferences.OP_TEMPERATURA_MJERENA)
      );
      this.deviceList = mapDeviceList(data.point.points);
      this.mapComponentLists();
      layoutActions.hideLoader();
    };

    FacilityKarcherDetailsViewModel.prototype.setFacilityIcon = function (
      data
    ) {
      switch (data.facilityType) {
        case 'JETWASH':
          return 'assets/images/self_service_new.svg';
        case 'ROLLOVER':
          return 'assets/images/rollover_new.svg';
        case 'CHANGER':
          return 'assets/images/changer_new.svg';
      }
    };

    FacilityKarcherDetailsViewModel.prototype.mapComponentLists = function () {
      this.globalListObject = {};
      var that = this;
      var tempPumpList = [];
      for (var i = 0; i < this.selectedDevice.point.points.length; i++) {
        if (
          this.selectedDevice.point.points[i].name.includes('OperationCounter')
        ) {
          for (
            var j = 0;
            j < this.selectedDevice.point.points[i].feeds.length;
            j++
          ) {
            if (
              this.selectedDevice.point.points[i].feeds[j].reference === 'NAME'
            ) {
              this.operationCounterObject.name =
                this.selectedDevice.point.points[i].feeds[j].currentValue;
            } else if (
              this.selectedDevice.point.points[i].feeds[j].reference ===
              'SECONDS'
            ) {
              // Transform from seconds to hours
              this.operationCounterObject.time =
                this.selectedDevice.point.points[i].feeds[j].currentValue;
            }
          }
          this.operationCounterObject.points =
            this.selectedDevice.point.points[i].points;

          // Check for device service flag
          onDeviceLevelServiceAlert(this, this.operationCounterObject);
          this.operationCounterList.push(this.operationCounterObject);
          this.operationCounterObject = {};
        } else if (
          this.selectedDevice.point.points[i].name.includes('Programs')
        ) {
          this.programPointId = this.selectedDevice.point.points[i].id;
          this.programPointPath = this.activePath + '/' + this.programPointId;
          this.globalListObject.programList = {
            path: this.programPointPath,
            list: this.selectedDevice.point.points[i].points
          };
        } else if (this.selectedDevice.point.points[i].name.includes('Pump_')) {
          this.pumpPointId = this.selectedDevice.point.points[i].id;
          tempPumpList.push({
            pumpName: this.selectedDevice.point.points[i].name,
            programsList: this.selectedDevice.point.points[i].points,
            path: this.activePath + '/' + this.pumpPointId
          });
        } else if (
          this.selectedDevice.point.points[i].name.includes('ActiveProgram')
        ) {
          this.activeProgramItem = this.selectedDevice.point.points[i];
          $timeout(function () {
            var idFeed = that.activeProgramItem.feeds.find(function(f) {
              return f.reference === 'ID';
            });
            if (idFeed) {
              that.mapActiveProgramName(
                idFeed.currentValue.replace('.0', ''),
                that.globalListObject.programList.list
              );
            }
          }, 50);
        } else if (
          this.selectedDevice.point.points[i].name.includes('Dosings')
        ) {
          this.dosingPointId = this.selectedDevice.point.points[i].id;
          this.dosingPointPath = this.activePath + '/' + this.dosingPointId;
          this.globalListObject.dosingList = {
            path: this.dosingPointPath,
            list: this.selectedDevice.point.points[i].actuators.map(function (
              item
            ) {
              that.rolloverDosingActuatorList.push(item.reference);
              return {
                id: item.id,
                value: parseInt(item.value),
                name: item.reference,
                state: item.state
              };
            })
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('Speeds')
        ) {
          this.speedsPointId = this.selectedDevice.point.points[i].id;
          this.speedsPointPath = this.activePath + '/' + this.speedsPointId;
          this.globalListObject.speedList = {
            path: this.speedsPointPath,
            list: this.selectedDevice.point.points[i].actuators.map(function (
              item
            ) {
              that.rolloverSpeedsActuatorList.push(item.reference);
              return {
                id: item.id,
                value: parseInt(item.value),
                name: item.reference,
                state: item.state
              };
            })
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('Parameters')
        ) {
          this.parametersPointId = this.selectedDevice.point.points[i].id;
          this.parametersList = this.selectedDevice.point.points[
            i
          ].actuators.map(function (item) {
            that.rolloverParametersActuatorList.push(item.reference);
            return {
              id: item.id,
              value: parseInt(item.value),
              name: item.reference,
              state: item.state
            };
          });
        } else if (
          this.selectedDevice.point.points[i].name.includes(
            'OperatingTimeVacuums'
          )
        ) {
          this.globalListObject.operatingTimeVacuumList = {
            path:
              this.activePath + '/' + this.selectedDevice.point.points[i].id,
            list: this.selectedDevice.point.points[i].points
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('IlluminationTime')
        ) {
          this.globalListObject.illuminationTimeList = {
            path:
              this.activePath + '/' + this.selectedDevice.point.points[i].id,
            list: this.selectedDevice.point.points[i].points,
            deviceType: this.selectedDevice.deviceType
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('OperatingTime')
        ) {
          this.globalListObject.operatingTimeList = {
            path:
              this.activePath + '/' + this.selectedDevice.point.points[i].id,
            list: this.selectedDevice.point.points[i].points
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('OpenDoors')
        ) {
          this.selectedDevice.point.points[i].actuators[0].value = Number(new Date().getTime());
          this.openDoorsActuator =
            this.selectedDevice.point.points[i].actuators;
          this.openDoorsId = this.selectedDevice.point.points[i].id;
        } else if (
          this.selectedDevice.point.points[i].name.includes('RemoteResetStart')
        ) {
          this.selectedDevice.point.points[i].actuators[0].value = Number(new Date().getTime());
          this.resetRolloverActuator =
            this.selectedDevice.point.points[i].actuators;
          this.resetRolloverId = this.selectedDevice.point.points[i].id;
        }
      }
      this.globalListObject.pumpsList = tempPumpList;
    };

    FacilityKarcherDetailsViewModel.prototype.updateFeedValues = function (
      newFeedData
    ) {
      var that = this;
      $timeout(function () {
        // On every feed update, update last synchronization
        that.lastReportTimestamp = moment(
          newFeedData.data.lastUpdate
        ).fromNow();
        if (newFeedData.data.reference === 'OP_TEMPERATURA_MJERENA') {
          that.feedReferences.OP_TEMPERATURA_MJERENA =
            newFeedData.data.currentValue;
          switch (true) {
            case that.feedReferences.OP_TEMPERATURA_MJERENA > 23:
              that.weatherIcon = 'assets/images/weather_sunny.png';
              break;
            case 7 < that.feedReferences.OP_TEMPERATURA_MJERENA &&
              that.feedReferences.OP_TEMPERATURA_MJERENA < 23:
              that.weatherIcon = 'assets/images/weather_cloud.png';
              break;
            case that.feedReferences.OP_TEMPERATURA_MJERENA < 7:
              that.weatherIcon = 'assets/images/weather_snow.png';
              break;
          }
        } else if (newFeedData.data.reference === 'STATE') {
          that.status = newFeedData.data.currentValue;
        } else if (newFeedData.data.reference === 'CURRENT_PROGRESS') {
          that.activeProgramUpdatedFeed = {
            value: newFeedData.data.currentValue,
            reference: 'CURRENT_PROGRESS'
          };
        } else if (newFeedData.data.reference === 'CURRENT_TIMEOUT_SEC') {
          that.activeProgramUpdatedFeed = {
            value: newFeedData.data.currentValue,
            reference: 'CURRENT_TIMEOUT_SEC'
          };
        } else if (newFeedData.data.reference.includes('CHEM_LEVEL_LOW_')) {
          that.chemicalLevelList.forEach(function (item) {
            if (item.levelName === newFeedData.data.reference) {
              item.levelValue = newFeedData.data.currentValue;
            }
          });
        } else if (newFeedData.data.reference.includes('CHEM_LEVEL_')) {
          that.chemicalLevelList.forEach(function (item) {
            if (item.name === newFeedData.data.reference) {
              item.value = newFeedData.data.currentValue;
            }
          });
        } else if (newFeedData.data.reference === 'STATUS_ID') {
          that.rolloverStatus = newFeedData.data.currentValue;
        }

        // Update devices value
        that.deviceList.forEach(function (point) {
          if (
            newFeedData.path.indexOf(
              that.deviceSerial + '/' + that.facilityId + '/' + point.pointId
            ) > -1
          ) {
            if (newFeedData.data.reference === 'OP_BUTTON') {
              point.OP_BUTTON = newFeedData.data.currentValue;
            } else if (
              newFeedData.data.reference === 'STATUS_BAY_ACTIVE_PROGRAM_NAME'
            ) {
              point.STATUS_BAY_ACTIVE_PROGRAM_NAME =
                newFeedData.data.currentValue;
            } else if (newFeedData.data.reference === 'STATUS_BAY_RUN_TIME') {
              point.STATUS_BAY_RUN_TIME = newFeedData.data.currentValue;
            } else if (newFeedData.data.reference === 'STATUS_BAY_CREDIT') {
              point.STATUS_BAY_CREDIT = newFeedData.data.currentValue;
            }
          }
        });

        // Update rollover active program data
        if (that.facilityType === 'JETWASH') {
          return;
        }
        if (
          newFeedData.path.indexOf(
            that.deviceSerial +
              '/' +
              that.facilityId +
              '/' +
              that.activeProgramItem.id
          ) > -1
        ) {
          that.activeProgramItem.feeds.forEach(function (item) {
            if (newFeedData.data.reference === 'CURRENT_PROGRESS') {
              item.currentValue = newFeedData.data.currentValue;
            }
            if (newFeedData.data.reference === 'CURRENT_TIMEOUT_SEC') {
              item.currentValue = newFeedData.data.currentValue;
            }
          });
        }
      }, 50);
    };

    FacilityKarcherDetailsViewModel.prototype.updateActuatorValues = function (
      newActuatorData
    ) {
      var that = this;
      $timeout(function () {
        // New global object approach for updating values from webSocket topics
        for (var key in that.globalListObject) {
          if (
            newActuatorData.path.indexOf(that.globalListObject[key].path) > -1
          ) {
            that.globalListObject[key].list.forEach(function (item) {
              if (
                that.globalListObject[key].path + '/' + item.id ===
                newActuatorData.path
              ) {
                item.actuators.forEach(function (actuator) {
                  if (actuator.id === newActuatorData.data.id) {
                    actuator.value = /^\d+$/.test(newActuatorData.data.value)
                      ? parseInt(newActuatorData.data.value)
                      : newActuatorData.data.value;
                    actuator.state = newActuatorData.data.state;
                  }
                });
              } else if (item.name === newActuatorData.data.reference) {
                item.value = parseInt(newActuatorData.data.value);
                item.state = newActuatorData.data.state;
              }
            });
          }
        }

        // For pump actuators only
        if (that.globalListObject.pumpsList) {
          that.globalListObject.pumpsList.forEach(function (pump) {
            if (newActuatorData.path.indexOf(pump.path) > -1) {
              pump.programsList.forEach(function (item) {
                if (pump.path + '/' + item.id === newActuatorData.path) {
                  item.actuators.forEach(function (actuator) {
                    if (actuator.id === newActuatorData.data.id) {
                      actuator.value = /^\d+$/.test(newActuatorData.data.value)
                        ? parseInt(newActuatorData.data.value)
                        : newActuatorData.data.value;
                      actuator.state = newActuatorData.data.state;
                    }
                  });
                }
              });
            }
          });
        }

        // IMPORTANT!!! ngChange in component works only if angular.copy exist
        that.globalListObject = angular.copy(that.globalListObject);

        // Update rollover active program data
        if (that.facilityType === 'JETWASH') {
          return;
        }
        if (
          newActuatorData.path.indexOf(
            that.deviceSerial +
              '/' +
              that.facilityId +
              '/' +
              that.activeProgramItem.id
          ) > -1
        ) {
          that.activeProgramItem.actuators.forEach(function (item) {
            if (item.reference === 'ID') {
              item.value = newActuatorData.data.value;
            }
          });
        }
      }, 50);
    };

    FacilityKarcherDetailsViewModel.prototype.updateEventValues = function(newEventData) {
      var that = this;
      $timeout(function () {
        newEventData.pullDate = new Date();
        that.fromWebSocketsEventData = newEventData;
        layoutActions.hideLoader();
      }, 50)
    }

    FacilityKarcherDetailsViewModel.prototype.createChemicalLevelList =
      function (data) {
        var tempArray = [],
          tempObj = {};
        for (var i = 0; i < this.listOfExistingChemicals.length; i++) {
          for (var j = 0; j < data.length; j++) {
            if (
              data[j].reference ===
              'CHEM_LEVEL_LOW_' + this.listOfExistingChemicals[i]
            ) {
              tempObj.levelName = data[j].reference;
              tempObj.levelValue = data[j].currentValue;
            } else if (
              data[j].reference ===
              'CHEM_LEVEL_' + this.listOfExistingChemicals[i]
            ) {
              tempObj.name = data[j].reference;
              tempObj.value = data[j].currentValue;
              tempArray.push(tempObj);
            }
          }
          tempObj = {};
        }
        return tempArray;
      };

    return FacilityKarcherDetailsViewModel;

    function setWeatherIcon(temp) {
      switch (true) {
        case temp > 23:
          return 'assets/images/weather_sunny.png';
        case 7 < temp && temp < 23:
          return 'assets/images/weather_cloud.png';
        case temp < 7:
          return 'assets/images/weather_snow.png';
        default:
          return 'assets/images/weather_sunny.png';
      }
    }

    function mapDeviceList(data) {
      var installedDeviceList = [],
        deviceObject = {},
        deletedPoint = null;
      for (var i = 0; i < data.length; i++) {
        deviceObject = {};
        // Avoid pushing point data if point includes white space in name. Example: "G0 1682088509559" (name with deleted timestamp)
        deletedPoint = data[i].name.includes(' ');
        for (var j = 0; j < data[i].feeds.length; j++) {
          if (
            data[i].feeds[j].reference === 'INSTALLED' &&
            data[i].feeds[j].currentValue === '1.0'
          ) {
            deviceObject.deviceName = data[i].name;
            deviceObject.deviceType = data[i].pointType;
            deviceObject.pointId = data[i].id;
            deviceObject.deviceLabel = data[i].label;
            data[i].feeds.forEach(function (feed) {
              switch (feed.reference) {
                case 'OP_BUTTON':
                  deviceObject.OP_BUTTON = feed.currentValue;
                  break;
                case 'STATUS_BAY_ACTIVE_PROGRAM_NAME':
                  deviceObject.STATUS_BAY_ACTIVE_PROGRAM_NAME =
                    feed.currentValue;
                  break;
                case 'STATUS_BAY_RUN_TIME':
                  deviceObject.STATUS_BAY_RUN_TIME = feed.currentValue;
                  break;
                case 'STATUS_BAY_CREDIT':
                  deviceObject.STATUS_BAY_CREDIT = feed.currentValue;
                  break;
              }
            });
            if (!deletedPoint) {
              installedDeviceList.push(deviceObject);
            }
          }
        }
      }
      return installedDeviceList.length !== 0
        ? installedDeviceList
        : [{ deviceName: $translate.instant('DEVICE_NOT_INSTALLED') }];
    }

    function countAlarmsType(data) {
      var alarmTypeList = data.map(function (item) {
          return item.karcherFault.washFacilityStatus;
        }),
        warningCount = 0,
        alarmCount = 0;

      for (var i = 0; i < alarmTypeList.length; i++) {
        if (alarmTypeList[i] === 'WARNING') {
          warningCount++;
        } else if (alarmTypeList[i] === 'ALARM') {
          alarmCount++;
        }
      }
      return { warnings: warningCount, alarms: alarmCount };
    }

    function onDeviceLevelServiceAlert(that, counter) {
      for (var i = 0; i < counter.points.length; i++) {
        if (counter.points[i].name.includes('Service')) {
          for (var j = 0; j < counter.points[i].feeds.length; j++) {
            if (counter.points[i].feeds[j].reference === 'DUE') {
              that.serviceOnOperationCountersDeviceNeeded =
                counter.points[i].feeds[j].currentValue === '1.0';
            }
          }
        }
      }
    }

    function getOrderObject(order) {
      var result = {
        order: 'asc',
        orderBy: order
      };

      if (order.indexOf('-') > -1) {
        result.order = 'desc';
        result.orderBy = order.substring(1);
      }
      return result;
    }
  }
})();
